import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, Suspense as _Suspense, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "loading" }, "loading", -1)

import {
	computed, onUnmounted, watch
} from 'vue'
import {
	NConfigProvider, zhCN, dateZhCN, NLayout, NLayoutHeader, NLayoutContent, NLayoutFooter, NScrollbar, NDialogProvider
} from 'naive-ui'
import HeaderComp from '@/components/HeaderComp.vue'
import FooterComp from '@/components/FooterComp.vue'
import getBase from '@/utils/base';
import { useI18n } from 'vue-i18n';
import { closeWebSocket, sendWebSocket } from '@/utils/websocket';

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const { $api, $store } = getBase();
const { locale } = useI18n();
watch(() => $store.state.auth.user, (newValue, oldValue) => {
	closeWebSocket();
	if (null != newValue && null != newValue.id) {
		sendWebSocket("00000000", getAlarmData);
	}
})

// 获取到返回的数据
const getAlarmData = (data: any) => {
	console.log("getAlarmData", data);
}
// 销毁websocket
onUnmounted(() => {
	closeWebSocket();
})

let lang = locale;

const nlocale = computed(() => {
	let result;
	if ('en' == lang.value) {
		result = null;
	} else {
		result = zhCN;
	}
	return result;
});
const ndateLocale = computed(() => {
	let result;
	if ('en' == lang.value) {
		result = null;
	} else {
		result = dateZhCN;
	}
	return result;
});

$api.common.auth().then((res: any) => {
	console.log("auth", res)
	$store.commit('setAuth', res);
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(NConfigProvider), {
      locale: _unref(nlocale),
      "date-locale": _unref(ndateLocale)
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(NDialogProvider), null, {
          default: _withCtx(() => [
            _createVNode(_unref(NLayout), null, {
              default: _withCtx(() => [
                _createVNode(_unref(NLayoutHeader), null, {
                  default: _withCtx(() => [
                    _createVNode(HeaderComp)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(NLayoutContent), { style: {"height":"calc(100vh - 43px - 25px)"} }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(NScrollbar), { "x-scrollable": true }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createBlock(_Suspense, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_router_view)
                          ]),
                          fallback: _withCtx(() => [
                            _hoisted_1
                          ]),
                          _: 1
                        }))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(NLayoutFooter), { style: {"height":"25px"} }, {
                  default: _withCtx(() => [
                    _createVNode(FooterComp)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["locale", "date-locale"])
  ]))
}
}

})